import { memo } from 'react'

import { SVGProps } from './types/iconType'

export const UploadIcon = memo(({ style, className }: SVGProps) => {
  return (
    <svg style={style} className={className} viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M32.372 22.853a1.905 1.905 0 00-1.904 1.905v.724l-2.818-2.82a5.31 5.31 0 00-7.484 0l-1.333 1.334-4.723-4.725a5.425 5.425 0 00-7.483 0l-2.819 2.82v-10.67c0-1.051.853-1.904 1.905-1.904h13.33a1.905 1.905 0 000-3.81H5.712A5.714 5.714 0 000 11.421v22.862A5.714 5.714 0 005.713 40h22.85a5.714 5.714 0 005.713-5.716v-9.526a1.905 1.905 0 00-1.904-1.905zM5.712 36.19a1.905 1.905 0 01-1.904-1.906v-6.801l5.523-5.525a1.504 1.504 0 012.075 0l6.037 6.04 8.188 8.192H5.713zm24.756-1.906a1.696 1.696 0 01-.343 1.01l-8.588-8.63 1.333-1.334a1.466 1.466 0 012.095 0l5.503 5.544v3.41zM39.437 6.26L33.724.543a1.904 1.904 0 00-.628-.4 1.903 1.903 0 00-1.448 0c-.233.09-.447.227-.628.4l-5.713 5.716a1.914 1.914 0 002.704 2.705l2.457-2.477v10.65a1.905 1.905 0 103.808 0V6.487l2.457 2.477a1.904 1.904 0 002.704 0 1.906 1.906 0 000-2.705z"
        fillRule="evenodd"
      />
    </svg>
  )
})
